module.exports = __webpack_public_path__ + "img/img3.7a7fe3ee.png";